<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button v-if="hasExport" type="primary" :loading="exporting" @click="onExport">导出</el-button>
      </template>
      <el-form inline label-width="100px" class="global-form-label-width account-form" @submit.native.prevent>
        <!-- 文本筛选字段与后端查询参数一一对应。 -->
        <el-form-item v-for="field in textFilters" :key="field.key" :label="field.label">
          <el-input v-model="searchForm[field.key]" clearable :placeholder="'请输入' + field.label" @keyup.enter.native="onSearch" />
        </el-form-item>
<!--        <el-form-item label="订单类型">-->
<!--          <el-select v-model="searchForm.orderType" clearable placeholder="全部">-->
<!--            <el-option label="一口价" value="1" />-->
<!--            <el-option label="基差采购" value="2" />-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="订单状态">-->
<!--          <el-select v-model="searchForm.orderStatus" clearable placeholder="全部">-->
<!--            <el-option label="待审批" value="1" />-->
<!--            <el-option label="进行中" value="2" />-->
<!--            <el-option label="已完成" value="3" />-->
<!--            <el-option label="驳回作废" value="4" />-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="保证金类型">-->
<!--          <el-select v-model="searchForm.orderDepositType" clearable placeholder="全部">-->
<!--            <el-option label="比例保证金" value="1" />-->
<!--            <el-option label="固定保证金" value="2" />-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="订单日期">-->
<!--          <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
    <el-card shadow="never" class="mt10">
<!--      <el-alert title="基差采购仅展示主单，数量包含子单；损耗按已录入实发及实收数量的明细计算（实发－实收），未收货明细暂不计损耗。数量沿用品种单位，保留三位小数。" type="info" :closable="false" />-->
      <!-- 按图片红字顺序展示十列。 -->
      <el-table v-loading="loading" :data="tableData" stripe border size="mini" class="mt10">
        <el-table-column prop="userName" label="采购方" min-width="200" />
        <el-table-column prop="supplierName" label="供应商" min-width="200" />
        <el-table-column prop="contractNo" label="合同编号" min-width="180" />
        <el-table-column prop="orderNumber" label="订单编号" min-width="180" />
        <el-table-column prop="specName" label="品种" show-overflow-tooltip min-width="180" />
        <el-table-column prop="orderQuantity" label="订单数量" min-width="120" :formatter="formatQuantity" />
        <el-table-column prop="shippedQuantity" label="实发数量" min-width="120" :formatter="formatQuantity" />
        <el-table-column prop="receivedQuantity" label="实收数量" min-width="120" :formatter="formatQuantity" />
        <el-table-column prop="lossQuantity" label="损耗" min-width="120" :formatter="formatQuantity" />
        <el-table-column prop="lossBearerName" label="损耗承担方" min-width="150" />
      </el-table>
      <el-pagination class="mt15" :current-page.sync="page" :page-size="10" :total="total" background layout="total, prev, pager, next" @current-change="loadData" />
    </el-card>
  </div>
</template>

<script>
import { exportFiles } from '@/utils/globalMethods'

/** 创建空筛选条件，确保重置后的字段保持响应式。 */
function emptyFilters() {
  return {
    // 采购方名称。
    buyerName: '',
    // 供应商名称。
    userName: '',
    // 合同编号。
    contractNo: '',
    // 主单或子单订单编号。
    orderNumber: '',
    // 外部点价编号。
    priceOrderNo: '',
    // 品种名称。
    specName: '',
    // 一口价或基差采购。
    orderType: '',
    // 主订单状态。
    orderStatus: '',
    // 保证金类型。
    orderDepositType: ''
  }
}

export default {
  /** 初始化查询与页面状态。 */
  data() {
    return {
      // 文本筛选项，各对象分别定义请求字段键和中文标签。
      textFilters: [
        // { key: 'buyerName', label: '采购方' },
        { key: 'contractNo', label: '合同编号' },
        { key: 'orderNumber', label: '订单编号' },
        { key: 'userName', label: '供应商名称' }
        // { key: 'priceOrderNo', label: '外部点价编号' },
        // { key: 'specName', label: '商品名称' }
      ],
      // 当前输入条件。
      searchForm: emptyFilters(),
      // 合同创建日期区间。
      dateRange: [],
      // 已应用条件，翻页与导出共用。
      appliedFilters: {},
      // 当前页码。
      page: 1,
      // 主合同总条数。
      total: 0,
      // 当前页数据。
      tableData: [],
      // 列表加载状态。
      loading: false,
      // 导出加载状态。
      exporting: false,
      // 请求序号，防止较早响应覆盖最新查询。
      requestId: 0
    }
  },
  computed: {
    /** 沿用采购订单的导出按钮权限。 */
    hasExport() {
      return this.$store.state.buttonList.some(item => item.butCode === 'export')
    }
  },
  /** 继承采购入口订单类型并加载统计。 */
  created() {
    this.searchForm.orderType = this.$route.query.orderType || ''
    this.onSearch()
  },
  methods: {
    /** 应用条件并返回第一页，翻页及导出均沿用本次条件。 */
    onSearch() {
      this.appliedFilters = {
        ...this.searchForm,
        // 起止日期为空时不限制查询范围。
        startDate: this.dateRange && this.dateRange[0],
        endDate: this.dateRange && this.dateRange[1]
      }
      this.page = 1
      this.loadData()
    },
    /** 清空筛选并立即刷新结果。 */
    onReset() {
      this.searchForm = emptyFilters()
      this.dateRange = []
      this.onSearch()
    },
    /** 读取分页统计，忽略旧请求响应，失败时清空陈旧数据。 */
    async loadData() {
      const requestId = ++this.requestId
      this.loading = true
      try {
        const result = await this.$axios.get(this.$apis.yxcOrderManage.selectLossReportByPage, {
          ...this.appliedFilters,
          // 每页固定十条。
          page: this.page,
          size: 10
        })
        if (requestId !== this.requestId) return
        this.tableData = result.list
        this.total = result.total
      } catch (error) {
        if (requestId !== this.requestId) return
        this.tableData = []
        this.total = 0
        this.$message.error(error.message || '损耗统计查询失败')
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    },
    /** 数量统一保留三位小数，允许零值和负损耗。 */
    formatQuantity(row, column, value) {
      return value == null ? '--' : Number(value).toFixed(3)
    },
    /** 导出当前已应用条件的全部记录，避免重复提交。 */
    async onExport() {
      this.exporting = true
      try {
        await exportFiles(this.$apis.yxcOrderManage.exportLossReport, this.appliedFilters, '损耗统计.xlsx')
      } finally {
        this.exporting = false
      }
    }
  }
}
</script>
